import * as XLSX from "xlsx";
import { parseBackendErrorMessage } from "./parseBackendError";

export const exportErrorsToExcel = (errores, options = {}) => {
  const { filename = "errores_lote.xlsx", sheetName = "Errores", schema, parseMessage = parseBackendErrorMessage } = options;

  if (!Array.isArray(schema) || schema.length === 0) {
    throw new Error("exportErrorsToExcel requiere un schema de columnas.");
  }

  const normalizeErrs = (item) =>
    Array.isArray(item?.errors) ? item.errors : [{ message: item?.message || item?.error || "Error", code: item?.code }];

  const data = (errores || []).map((item) => {
    const errs = normalizeErrs(item);

    const entries = schema
      .map((col) => {
        const header = col.header;
        const val = typeof col.value === "function" ? col.value(item, errs, parseMessage) : col.key ? item[col.key] : undefined;

        if (val == null || String(val).trim() === "") return null;
        return [header, val];
      })
      .filter(Boolean);

    return Object.fromEntries(entries);
  });

  const worksheet = XLSX.utils.json_to_sheet(data);

  worksheet["!cols"] = schema.map((c) => ({ wch: c.width ?? 20 }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, filename);
};
